export class TipoPoder {
  nombre: string;
  codigo: string;
  descripcion: string;
  imagen: string;
}
